// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"ModalHeader_modalHeader__1zRdC","closeIcon":"ModalHeader_closeIcon__6AY_x"};